"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _commentsContext = _interopRequireDefault(require("../contexts/commentsContext")),
    _commentsContext2 = _interopRequireDefault(require("../selectors/commentsContext")),
    _utils = require("../utils"),
    _orderByTimestamp = _interopRequireDefault(require("../utils/orderByTimestamp")),
    _parseJSON = _interopRequireDefault(require("../../../common/utils/parseJSON"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var CommentsProvider = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), _initialiseProps.call((0, _assertThisInitialized2["default"])(d));
    var e = new Map([]);
    return d.state = {
      comments: e,
      userAssignedColors: {},
      commentModalProps: {}
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this.props.resourceId;
      this.fetchComments(a);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(a) {
      var b = a.resourceId,
          c = this.props.resourceId;
      b === c || this.fetchComments(c);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.comments,
          c = a.userAssignedColors,
          d = a.commentModalId,
          e = a.commentModalProps,
          f = a.closeModalOrigin,
          g = this.props,
          h = g.children,
          i = g.updateViewersRequest,
          j = g.filterByMetadataFlag,
          k = g.resourceId,
          l = g.resourceOrganisationId,
          m = g.canResolveComment,
          n = g.isReadOnly,
          o = g.modalTarget;
      return _react["default"].createElement(_commentsContext["default"].Provider, {
        value: (0, _commentsContext2["default"])({
          state: {
            comments: this.getFilteredCommentsForResource(k, b),
            userAssignedColors: c,
            commentModalId: d,
            commentModalProps: e,
            modalTarget: o,
            filterByMetadataFlag: j,
            isReadOnly: n,
            canResolveComment: m,
            resourceOrganisationId: l,
            closeModalOrigin: f
          },
          actions: {
            deleteComment: this.deleteComment,
            updateComment: this.updateComment,
            createComment: this.createComment,
            createReply: this.createReply,
            updateViewers: i,
            deleteReply: this.deleteReply,
            getUserColor: this.fetchUserColor,
            showCommentModal: this.showCommentModal,
            closePopover: this.closeCommentModal,
            getOrderedComments: this.getOrderedComments
          }
        })
      }, h);
    }
  }]), b;
}(_react.Component);

exports["default"] = CommentsProvider;

var _initialiseProps = function _initialiseProps() {
  var a = this;
  this.getUserColors = (0, _memoizeOne["default"])(function (a) {
    var b = a.comments;
    return (0, _utils.generateUserColors)({
      userIds: b.map(function (a) {
        var b = a.createdByUser.userId;
        return b;
      })
    });
  }), this.getFilteredCommentsForResource = function (b, c) {
    var d = a.props.filterByMetadataFlag,
        e = new Map();
    return c.forEach(function (a, c) {
      if (a.resourceId === b) {
        if (!d) return void e.set(c, a);

        if (a.metadata) {
          var f = (0, _parseJSON["default"])(a.metadata),
              g = d.key,
              h = d.value;
          return f[g] === h ? void e.set(c, a) : void 0;
        }
      }
    }), e;
  }, this.fetchUserColor = function () {
    var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        c = b.userId,
        d = a.state.userAssignedColors,
        e = (0, _utils.getUserColor)({
      userAssignedColors: d,
      userId: c
    }),
        f = e.userColor,
        g = e.updatedUserColors;
    return g && a.setState({
      userAssignedColors: g
    }), f;
  }, this.fetchComments = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
      var d, e, f, g, h, i;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return d = a.props, e = d.getCommentsRequest, f = d.fetchAssets, b.next = 3, e(c);

            case 3:
              if (g = b.sent, h = g.data, i = g.error, !i && h && h.getComments) {
                b.next = 8;
                break;
              }

              return b.abrupt("return");

            case 8:
              f(h), a.setState({
                comments: new Map(h.getComments.map(function (a) {
                  return [a.commentId, a];
                })),
                userAssignedColors: a.getUserColors({
                  comments: h.getComments
                })
              });

            case 10:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.handleCommentAssetsChange = function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [],
        c = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [],
        d = a.props.onCommentAssetsChange,
        e = b.filter(function (a) {
      return !c.includes(a);
    }),
        f = c.filter(function (a) {
      return !b.includes(a);
    });
    d && (e.length || f.length) && d({
      deleted: e,
      created: f
    });
  }, this.handleCommentUpdate = function (b) {
    a.setState(function (c) {
      var d = c.comments,
          e = d.get(b.commentId) || {},
          f = new Map([].concat((0, _toConsumableArray2["default"])(d), [[b.commentId, _objectSpread(_objectSpread(_objectSpread({}, e), b), {}, {
        fetching: !1
      })]]));
      return a.handleCommentAssetsChange(e.assetIds, b.assetIds), {
        comments: f,
        userAssignedColors: a.getUserColors({
          comments: Array.from(f.values())
        })
      };
    });
  }, this.deleteComment = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
      var d, e, f, g, h;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return d = c.commentId, e = c.onSuccess, f = a.props.deleteCommentRequest, b.next = 4, f({
                commentId: d
              });

            case 4:
              if (g = b.sent, h = g.error, !h) {
                b.next = 8;
                break;
              }

              return b.abrupt("return");

            case 8:
              a.setState(function (b) {
                var c = b.comments,
                    e = new Map((0, _toConsumableArray2["default"])(c));
                return a.handleCommentAssetsChange((0, _lodash["default"])(e.get(d), "assetIds"), []), e["delete"](d), {
                  comments: e
                };
              }, function () {
                e && e({
                  commentId: d
                });
              });

            case 9:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.deleteReply = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
      var d, e, f, g, h, i, j, k;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return d = c.commentId, e = c.parentComment, f = c.parentComment.children, g = void 0 === f ? [] : f, h = a.props.deleteCommentRequest, b.next = 4, h({
                commentId: d
              });

            case 4:
              if (i = b.sent, j = i.error, !j) {
                b.next = 8;
                break;
              }

              return b.abrupt("return");

            case 8:
              k = g.findIndex(function (a) {
                return a.commentId === d;
              }), a.handleCommentUpdate(_objectSpread(_objectSpread({}, e), {}, {
                children: [].concat((0, _toConsumableArray2["default"])(g.slice(0, k)), (0, _toConsumableArray2["default"])(g.slice(k + 1)))
              }));

            case 10:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.createComment = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
      var d, e, f, g, h, i, j;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return d = c.input, e = a.props, f = e.createCommentRequest, g = e.resourceId, b.next = 4, f(_objectSpread(_objectSpread({}, d), {}, {
                resourceId: g
              }));

            case 4:
              if (h = b.sent, i = h.data, j = h.error, i && !j) {
                b.next = 9;
                break;
              }

              return b.abrupt("return", {
                data: i,
                error: j
              });

            case 9:
              return a.handleCommentUpdate(i.createComment), b.abrupt("return", {
                data: i
              });

            case 11:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.createReply = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c) {
      var d, e, f, g, h, i, j, k, l, m, n;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return d = c.input, e = c.parentComment, f = c.parentComment.children, g = void 0 === f ? [] : f, h = a.props, i = h.createCommentRequest, j = h.resourceId, b.next = 4, i(_objectSpread(_objectSpread({}, d), {}, {
                resourceId: j
              }));

            case 4:
              if (k = b.sent, l = k.data, m = k.error, !m && l) {
                b.next = 9;
                break;
              }

              return b.abrupt("return", {
                error: m
              });

            case 9:
              return n = _objectSpread(_objectSpread({}, e), {}, {
                children: [].concat((0, _toConsumableArray2["default"])(g), [l.createComment])
              }), a.handleCommentUpdate(n), b.abrupt("return", {
                data: l
              });

            case 12:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.updateComment = function () {
    var b = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function b(c, d) {
      var e, f, g, h;
      return _regenerator["default"].wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return e = a.props.updateCommentRequest, a.handleCommentUpdate(_objectSpread({
                commentId: c
              }, d)), b.next = 4, e({
                commentId: c,
                input: d
              });

            case 4:
              if (f = b.sent, g = f.data, h = f.error, !h && g) {
                b.next = 9;
                break;
              }

              return b.abrupt("return", {
                error: h
              });

            case 9:
              return b.abrupt("return", {
                data: g
              });

            case 10:
            case "end":
              return b.stop();
          }
        }
      }, b);
    }));
    return function () {
      return b.apply(this, arguments);
    };
  }(), this.showCommentModal = function (b, c) {
    b && a.setState({
      commentModalId: b,
      commentModalProps: _objectSpread({}, c)
    });
  }, this.closeCommentModal = function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
        c = b.closeModalOrigin;
    a.setState({
      commentModalId: void 0,
      commentModalProps: void 0,
      closeModalOrigin: c
    });
  }, this.getOrderedComments = function (b) {
    var c = a.props.resourceId,
        d = a.state,
        e = d.userAssignedColors,
        f = d.comments,
        g = a.getFilteredCommentsForResource(c, f);
    return (0, _orderByTimestamp["default"])(e, g, b);
  };
};